import React from 'react';

import { CloudProvider } from '@ariksa/inventory-core';
import { Box, HStack, Stack, Text } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

import { DottedUnderlineLink } from 'components/DataDisplay';
import { Select } from 'components/DataEntry';
import { renderDataPolicyConditionLabel } from 'containers/Jit/MaskingPolicies/Components/DataPolicyWizard/utils';
import { seletMaskingPolicies } from 'containers/Jit/MaskingPolicies/selectors';
import { LearnMoreFieldType } from 'containers/SharedState/types';

interface Props {
  state: Record<string, any>;
  updateState: (state: any) => void;
  setLearnMore: (learnMore: LearnMoreFieldType) => void;
}

export const DataPolicyLabelCriteria = (props: Props) => {
  const { state, updateState, setLearnMore } = props;
  const { tagKeyValues } = useSelector(seletMaskingPolicies);
  const isSnowflake =
    state?.account?.data?.provider === CloudProvider.Snowflake;

  return (
    <Stack spacing={5}>
      <HStack justify="space-between">
        {renderDataPolicyConditionLabel(
          'FOR',
          isSnowflake
            ? 'Sensitive Data Tag Name'
            : 'the following tag at the column level',
          isSnowflake,
        )}
        <DottedUnderlineLink
          label="What's this"
          onClick={() => setLearnMore('column_labels_in_snowflake')}
        />
      </HStack>
      <Box w="65%" borderRadius={6} bg="white">
        <Select
          options={state?.tagOptions}
          value={state?.tag}
          showClearIndicator={false}
          onChange={val => updateState({ tag: val })}
          isLoading={tagKeyValues.isLoading}
          showIconInValueContainer={false}
        />
      </Box>
    </Stack>
  );
};
